import { useEffect, useState } from "react"
import { formState } from "../../interfaces/LoginInterfaces"
import { Text } from "../units/Text"
import { useAuthContext, AuthContextType } from "../../context/AuthContextProvider"
import { LgFormCkeckBox, PolicyFormCkeckBox, Input, PasswordInput } from "../Form/FormInput"
import { BoxWrapper, FlexWrapper } from "../Wrappers/Wrappers"
import { AxiosRestorePassword, AxiosNewAccount } from "../Rest/RestorePassword"
import { RestApiState } from "../Rest/Organization"
import { SubmitButton } from "../Buttons/buttons"


interface AuthFormProps {
    username: string;
    password: string;
    rememberMe: boolean;
    agreement: boolean;
    userNameError?: string;
    passwordError?: string;
    policyError?: string;
}


const defaultProps = {
    username: "",
    password: "",
    rememberMe: true,
    agreement: true,
    userNameError: undefined,
    passwordError: undefined
}


export const AuthForm = (formView:formState, setFormState: (value:any) => void, setVisible: (value: boolean) => void, token: string) => {
    const [props, setProps] = useState<AuthFormProps>(defaultProps)
    const authContext: AuthContextType = useAuthContext()

    const handleLogin = (e: any) => {
        e.preventDefault()

        if (token === "") {
            setVisible(true)

        } else {
            var validFields = true
            if (props.username === ""){
                validFields = false
                setProps((prev) => ({...prev, userNameError: "Поле должно быть заполнено"})) 
            }

            if (props.password === "") {
                validFields = false
                setProps((prev) => ({...prev, passwordError: "Поле должно быть заполнено"}))
            }

            if (validFields) {
                authContext.login(props.username, props.password, props.rememberMe)
            }
        }
        
    }

    const usernameContainChar = props.username !== "" ? true : false
    const passwordContainChar = props.password !== "" ? true : false

    const isDisabled = usernameContainChar && passwordContainChar && props.agreement === true ? false : true
    const isHidden = formView === formState.LoginView ? false : true
    
    // function welcome() {
    //     const date = new Date();
    //     const hour = date.getHours()

    //     if (hour > 5 && hour < 12) {
    //         return "Дорбое утро!"
    //     } else if (hour >= 12 && hour < 18) {
    //         return "Дорбый день!"
    //     } else if (hour >= 18 && hour < 21) {
    //         return "Дорбый вечер!"
    //     } else {
    //         return "Дорбой ночи!"
    //     }
        
    // }

    return  (
        <BoxWrapper p="p0" className="relative show-up-quick full-height" >
            {/* <Title>{welcome()}</Title> */}
            {/* <Text color="secondary">Для входа введите логин и пароль</Text> */}
            <form onSubmit={handleLogin} style={{display:`${ isHidden ? 'none' : 'block'}`}} className="full-height">
                <FlexWrapper flexDirection="column" justifyContent="space-between" className="full-height">
                    <FlexWrapper flexDirection="column" alignItems="stretch" className="normal-gap">
                        <Input 
                            label="Почта"
                            name={"username"}
                            inputError={props.userNameError}
                            required={true}
                            type={"text"}
                            height="cs-input-lg"
                            setter={
                                (e:any) => { 
                                    if (e.target.value !== "" && props.userNameError) { 
                                        setProps((prev) => ({...prev, userNameError: undefined })) 
                                    }
                                    setProps((prev) => ({...prev, username: e.target.value }))
                                }
                            }
                        />
                        <PasswordInput 
                            label="Пароль"
                            name={"password"}
                            inputError={props.passwordError}
                            required={true}
                            type={"password"}
                            height="cs-input-lg"
                            setter={(e:any) => { 
                                if (e.target.value !== "" && props.passwordError) { 
                                    setProps((prev) => ({...prev, passwordError: undefined })) 
                                }
                                setProps((prev) => ({...prev, password: e.target.value })) 
                            }}
                            setRestore={
                                (e:any) => { setFormState(formState.RestoreView) }
                            }
                        />
                        <PolicyFormCkeckBox 
                            value={props.agreement}
                            name="policy"
                            label=""
                            valueSetter={(e: any) => { setProps(prev => ({...prev, agreement: e.target.checked })) }}
                            required={true}
                            border={false}
                            p="p05"
                            textSize="base"
                        />
                        <LgFormCkeckBox 
                            value={props.rememberMe}
                            label="Запомнить меня"
                            name="policy"
                            valueSetter={(e: any) => { setProps(prev => ({...prev, rememberMe: e.target.checked })) }}
                            required={true}
                            border={false}
                            p="p05"
                            textSize="base"
                        />
                    </FlexWrapper>
                    <BoxWrapper p="p0" className="full-width">
                        <Text color="danger" className="text-center sm-height" size="sm">{authContext.authMessage}</Text>
                        <br />
                        <button
                            onClick={ (e: any) => {
                                if (isDisabled) {
                                    e.preventDefault()
                                    if (props.username === ""){
                                        setProps((prev) => ({...prev, userNameError: "Поле должно быть заполнено"})) 
                                    }
                            
                                    if (props.password === "") {
                                        setProps((prev) => ({...prev, passwordError: "Поле должно быть заполнено"}))
                                    }
                                }
                            }}
                            type="submit"
                            className={`p3 bold ${ props.agreement === false ? 'disabled' : ''}`}
                            // disabled={isDisabled}
                        >Войти</button>
                    </BoxWrapper>
                </FlexWrapper>
            </form>
        </BoxWrapper>
    )
}

interface RestorePasswordProps {
    email: string;
    emailError: string | undefined;
    requestState: RestApiState;
    timeOutId: NodeJS.Timeout | null;
    requestSent: boolean;
}

function initialSeconds():number { return 0 }

export const RestorePassword = (
    formView: formState, 
    setFormView: React.Dispatch<React.SetStateAction<formState>>,
    setVisible: (value: boolean) => void, 
    token: string
) => {
    const[userdata, setUserData] = useState<RestorePasswordProps>({   
            email: "", 
            emailError: undefined, 
            requestState: RestApiState.Idle,
            timeOutId: null,
            requestSent: false,
    })
    const [seconds, setSeconds] = useState<number>(initialSeconds());

    useEffect(() => {
        if (seconds > 0) {
            const intervalId = setInterval(() => {
                setSeconds(prevSeconds => prevSeconds - 1);
            }, 1000);

            // Clear the interval on component unmount or when seconds change
            return () => clearInterval(intervalId);
        }
        if (seconds === 0) { 
            setUserData(prev => ({...prev, requestSent:false})) 
            setUserData(prev => ({...prev, email:''})) 
        
        }
    }, [seconds]);


    useEffect(() => {
        if (userdata.requestState === RestApiState.Success) {
            setUserData((prev) => ({...prev, requestSent: true}))
            setSeconds(prevSeconds => 60);
        }
    }, [userdata.requestState])
    const formIsValid = ():boolean => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (emailRegex.test(userdata.email)) {
            return true;
        } else {
            return false
        }
    }

    const handelSubmit = (e: any) => {
        e.preventDefault();
        if (!formIsValid()) {
            return void setUserData((prev:RestorePasswordProps) => ({
                ...prev, emailError: "Почта не соответсвует требованиям"
            }));
        }

        if (token === "" && formIsValid()) {
            setVisible(true)
        }

        if (token !== "" && formIsValid()) {
            setUserData((prev) => ({
                ...prev, requestState : RestApiState.Pending
            }))
            return void AxiosRestorePassword(
                userdata.email, 
                (value: RestApiState) => { 
                    setUserData((prev:RestorePasswordProps) => ({
                        ...prev, requestState: value}))
                    }
            );      
        }
    }

    return (
        <BoxWrapper 
            className={'show-up-quick'} 
            // onClick={(e)=>setFormView(formState.LoginView)}
            p="p0"
            >
                { !userdata.requestSent ? (
                <BoxWrapper
                    p="p0"
                >
                    <Text size="xxl">
                        Востановить пароль
                    </Text>
                    <Text size="base" color="secondary">
                        Укажите почтовый ящик.
                    </Text>
                    <br />
                    <form onSubmit={handelSubmit}>
                        <Input
                            value={userdata.email}
                            label="Почта"
                            name={"email"}
                            inputError={userdata.emailError}
                            required={true}
                            type={"text"}
                            height="cs-input-lg"
                            setter={(e:any) => { 
                                if (e.target.value !== "" && userdata.emailError) { 
                                    setUserData((prev) => ({...prev, emailError: undefined })) 
                                }
                                setUserData((prev) => ({...prev, email: e.target.value })) 
                            }}
                            pattern = { "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" }
                            />
                            <SubmitButton 
                                restState={userdata.requestState}
                                restHandler={{
                                    timeOutId:userdata.timeOutId,
                                    setter: ( key: 'timeOutId' | 'requestState', value: any ) => {
                                        setUserData((prev) => ({
                                            ...prev, [key] : value
                                        }))
                                    }
                                    
                                }}
                                onClick={ (e: any) => {
                                    if (!formIsValid()) {
                                        e.preventDefault()
                                        return void setUserData(
                                            (prev) => ({...prev, emailError: "Почта не соответсвует требованиям"})
                                        )
                                    }
                                }}
                                disabled={false}
                                text="Востановить пароль"
                            />
                    </form>
                    
                </BoxWrapper>
                ) : (
                    <BoxWrapper 
                        className="show-up-quick" 
                        r="r10" 
                        p="p0" 
                        >
                        <FlexWrapper flexDirection="column">
                            <Text className="text-center">Ссылка на востановление пароля отправлена на почту <Text className="bold" color="orange">{userdata.email}</Text>✅✉️</Text>
                            <br />
                            <Text  className="text-center">Следующая попытка через {seconds}</Text>
                        </FlexWrapper>
  
                    </BoxWrapper>
                ) }
                
        </BoxWrapper>
    )
}


interface NewAccountProps {
    data: {
        full_name: string;
        position: string;
        company: string;
        phone: string;
        email: string;
        serials: string;
        comment: string;
    };
    requestState: RestApiState;
    timeOutId: NodeJS.Timeout | null;
    requestSent: boolean;

}

export const NewAccount = (
    formView:formState, 
    setFormView: React.Dispatch<React.SetStateAction<formState>>,
    setVisible: (value: boolean) => void, 
    token: string
) => {
    const [props, setProps] = useState<NewAccountProps>({
        data : {
            full_name: '',
            position: '',
            company: '',
            phone:'',
            email: '',
            serials: '',
            comment: '',
        },
        requestState: RestApiState.Idle,
        timeOutId: null,
        requestSent: false

    })
    const className = `show-up-quick full-height`

    const handleSubmit = (e: any) => {
        e.preventDefault()
        if (token === "") {
            setVisible(true)
        } else {
            setProps(prev => ({...prev, requestState: RestApiState.Pending}))
            AxiosNewAccount(props.data, (value: RestApiState) => {setProps(prev => ({...prev, requestState: value}))})
        }
    } 

    useEffect(() => {
        if (props.requestState === RestApiState.Success) {
            setProps(prev => ({...prev, requestSent: true}))
        }
    }, [props.requestState])
    return (
    
        <BoxWrapper
            p="p0"
            className={`${className} full-height flex flex-column`} 
        >
            <Text size="base" className="bold">
                Для регистрации обратитесь к Вашему поставщику Stark Lithium или заполните форму обратной связи:
            </Text>
            { !props.requestSent ? (

                <form onSubmit={handleSubmit} className="full-height">
                    <FlexWrapper flexDirection="column" justifyContent="space-between" className="full-height narrow-gap" flexWrap="nowrap">
                        <BoxWrapper p="p0" style={{overflow:"auto", height:"350px"}}>
                            <Input
                                value={props.data.full_name}
                                label="ФИО"
                                name={"full_name"}
                                required={true}
                                type={"text"}
                                height="cs-input-lg"
                                setter={(e:any) => setProps(prev => ({...prev, data: {
                                    ...prev.data, full_name: e.target.value}
                                }))}
                            />

                            <Input 
                                label="Должность"
                                name={"position"}
                                required={false}
                                type={"text"}
                                height="cs-input-lg"
                                setter={(e:any) => setProps(prev => ({...prev, data: {
                                    ...prev.data, position: e.target.value}
                                }))}
                                value={props.data.position}
                            />

                            <Input 
                                label="Компания"
                                name={"company"}
                                required={true}
                                type={"text"}
                                height="cs-input-lg"
                                setter={(e:any) => setProps(prev => ({...prev, data: {
                                    ...prev.data, company: e.target.value}
                                }))}
                                value={props.data.company}
                            />
                        
                            <Input 
                                label="Телефон"
                                name={"phone"}
                                required={true}
                                type={"text"}
                                height="cs-input-lg"
                                setter={(e:any) => setProps(prev => ({...prev, data: {
                                    ...prev.data, phone: e.target.value}
                                }))}
                                value={props.data.phone}
                                />

                            <Input 
                                label="Email"
                                name={"email"}
                                required={true}
                                type={"text"}
                                height="cs-input-lg"
                                setter={(e:any) => setProps(prev => ({...prev, data: {
                                    ...prev.data, email: e.target.value}
                                }))}
                                value={props.data.email}
                                pattern = { "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" }
                                />

                            <Input 
                                label="Серийный номер АКБ"
                                name={"serials"}
                                required={true}
                                type={"text"}
                                height="cs-input-lg"
                                setter={(e:any) => setProps(prev => ({...prev, data: {
                                    ...prev.data, serials: e.target.value}
                                }))}
                                value={props.data.serials}
                                />

                            <Input 
                                label="Сообщение"
                                name={"comment"}
                                required={false}
                                type={"text"}
                                height="cs-input-lg"
                                setter={(e:any) => setProps(prev => ({...prev, data: {
                                    ...prev.data, comment: e.target.value}
                                }))}
                                value={props.data.comment}
                                />

                            <LgFormCkeckBox 
                                value={true}
                                label="Даю согласие на обработку персональных данных в соответствии с Политикой конфиденциальности"
                                name="policy"
                                valueSetter={(e: any) => {}}
                                required={true}
                                border={false}
                                p="p05"
                                textSize="base"
                            />
                        </BoxWrapper>

                        <SubmitButton 
                            text={"Оставить заявку"}
                            disabled={false}
                            restHandler={{
                                timeOutId: props.timeOutId,
                                setter: (key: 'timeOutId' | 'requestState', value: RestApiState) => { setProps(prev=>({...prev, [key]: value})) }
                            }}
                            restState={props.requestState}
                        />
                    </FlexWrapper>
                </form>
            ) : (
                <BoxWrapper>
                    <FlexWrapper justifyContent="center" alignItems="center" flexDirection="column">
                        <Text>Заявка отправлена ✅</Text>
                    </FlexWrapper>
                </BoxWrapper>
            ) }
            
        </BoxWrapper>
    )
}